module.exports = __webpack_public_path__ + "static/img/plem06.e67985c.png";


//////////////////
// WEBPACK FOOTER
// ./static/plem06.png
// module id = fa+T
// module chunks = 1